import { MotorStatusMdl } from './MotorStatusMdl';
export class ProposalRes
{
  public RESULTFLAG: string;
  public ProposalNo: number;
  public ERRORMSG: string;
  public st: MotorStatusMdl=new MotorStatusMdl();
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/ProposalRes.ts